module.exports = __webpack_public_path__ + "static/messages_fotball-610263601e59cabcc9836bd5b944fd78.mp4";